import type { LigneVivier } from '../partage/api/types';
import { A_VERIFIER, C_EST_ARRIVE, RELANCER } from '../partage/vocabulaire';

/**
 * « À vérifier » sur « Maintenant » au téléphone (chantier telephone-habit, 04, maquette
 * `maintenant()`, `.postit`, `.punaise`) : un post-it jaune punaisé, une ligne écrite à la main
 * par réponse attendue, et ses gestes en mots soulignés. « C'est arrivé » toujours ; « Relancer »
 * quand l'attente dure trop (`a_verifier`), comme la ligne de l'ordinateur (`LigneAttente`).
 * Toucher le titre ouvre sa fiche. Sans attente, pas de post-it.
 */
export function AVerifierAuPouce({
  lignes,
  onOuvrir,
  onArrive,
  onRelancer,
}: {
  lignes: LigneVivier[];
  onOuvrir: (id: string) => void;
  onArrive: (id: string) => void;
  onRelancer: (id: string) => void;
}) {
  if (lignes.length === 0) return null;
  return (
    <section className="postit-pouce" aria-label={A_VERIFIER} data-tuto="groupe-a-verifier">
      <span className="postit-pouce-punaise" aria-hidden="true" />
      <h2 className="postit-pouce-titre">{A_VERIFIER}</h2>
      {lignes.map((l) => (
        <div key={l.id} className="postit-pouce-ligne">
          <button type="button" className="postit-pouce-quoi" onClick={() => onOuvrir(l.id)}>
            {l.titre}
          </button>
          {l.situation.nom === 'a_verifier' && (
            <button type="button" className="postit-pouce-geste" onClick={() => onRelancer(l.id)}>
              {RELANCER}
            </button>
          )}
          <button type="button" className="postit-pouce-geste" onClick={() => onArrive(l.id)}>
            {C_EST_ARRIVE}
          </button>
        </div>
      ))}
    </section>
  );
}
